import React, { useContext } from 'react';
import { get } from 'lodash';

import styled from 'styled-components';
import { FlexCenter, Small, Tooltip } from '@ubeya/shared-web/components';
import { ReactComponent as BaseErrorIcon } from '@ubeya/shared-web/assets/error.svg';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { ReactComponent as WarningIcon } from '@ubeya/shared-web/assets/warning-yellow.svg';

const ErrorIcon = styled(BaseErrorIcon)`
  margin-left: -4px;
  margin-bottom: 3px;
`;

const Label = styled(Small)`
  border-radius: 8px;
  padding: 4px 10px;
  margin: 0 2px;
`;

const Container = styled(FlexCenter)``;

const AWRWeeksRenderer = ({ rowData, dataKey }) => {
  const { t } = useContext(ConfigContext);
  const value = get(rowData, dataKey);

  if (!value) {
    return <></>;
  }
  const showWarning = value >= 6;
  const showError = value >= 12;

  return (
    <Container>
      <Label>{value}</Label>
      {showError ? (
        <Tooltip body={t('awrErrorTooltip')}>
          <ErrorIcon />
        </Tooltip>
      ) : showWarning ? (
        <Tooltip body={t('awrWarningTooltip')}>
          <WarningIcon />
        </Tooltip>
      ) : null}
    </Container>
  );
};

export default AWRWeeksRenderer;
